/* נכסי מדיה משותפים. ריכוז כאן מאפשר להחליף לוגו או תמונה
   במקום אחד, במקום לרדוף אחרי הנתיב בכל קובץ שמשתמש בו. */

/** לוגו סינרו בגרסה הלבנה, לשימוש על רקע כהה (כותרת, hero, כרטיסי יועצים). */
export const LOGO_URL = '/assets/logo-white.png';

/** לוגו סינרו בגרסה השחורה, לשימוש על רקע בהיר.
   נדרש ל-favicon: לשונית הדפדפן ומסך הבית מציגים רקע בהיר, ולוגו לבן
   על רקע לבן אינו נראה. מוגדר ב-index.html, שאינו יכול לקרוא מכאן,
   ולכן שינוי נתיב מחייב עדכון גם שם.

   הקובץ מוקטן ל-512px — די והותר לגודלי favicon, וחוסך למעלה מ-190kB
   בכל טעינת עמוד. המקור המלא נשמר כ-logo-black-full.png לשימוש עתידי
   (הדפסה, מצגות) ואינו נטען על ידי האתר. */
export const LOGO_DARK_URL = '/assets/logo-black.png';

/** תמונת רקע ל-hero, מוצגת עד שהווידאו נטען. */
export const HERO_POSTER_URL = '/assets/hero.jpg';
